module.exports = __webpack_public_path__ + "img/logo_Ahex.8cf745e8.png";